import React from 'react';
import { MorphStage } from '../MorphStage';
import { PillButton } from '../PillButton';
import { useBeats } from '../../hooks/useBeats';
import { deviations, planToBond } from '../../data/teaser';
const BEATS = [1400, 1700, 2000, 2800, 3600, 4200];
interface ScreenVariabilityProps {
  onOpenPoll: () => void;
}
export function ScreenVariability({
  onOpenPoll
}: ScreenVariabilityProps) {
  const beat = useBeats(BEATS);
  return <section className="flex h-full w-full flex-col justify-center" data-id="element-152" data-mp="kbr3wnoddr20">
      <h1 className="text-[27px] font-extrabold leading-[1.15] text-white animate-fade-in-up" data-id="element-153" data-mp="fdfuge1zlikb">
        That’s where variability can enter.
      </h1>

      <div className="mt-6 animate-fade-in" data-id="element-154" data-mp="al64wz4sakik">
        <MorphStage morph={planToBond} heightClass="h-44" holdMs={2000} data-id="element-155" data-mp="5oo0y1ha2q7a" />
      </div>

      <ul className="mt-4 flex items-center gap-2" aria-label="Where variability can enter" data-id="element-156" data-mp="133a4knux8t0v">
        {deviations.map((deviation, index) => <li key={deviation.name} className={`flex-1 rounded-full border border-white/12 bg-white/[0.03] py-1.5 text-center font-headline text-[10px] font-bold uppercase tracking-[0.18em] text-white/70 transition-[opacity,transform] duration-300 ease-out ${beat >= index + 1 ? 'translate-y-0 opacity-100' : 'translate-y-1 opacity-0'}`} data-id="element-157" data-mp="yaqp1lcobntf" data-mpi={index}>
            {deviation.name}
          </li>)}
      </ul>

      <p className={`mt-7 font-headline text-[21px] font-extrabold leading-snug text-solventum-primary transition-[opacity,transform] duration-300 ease-out ${beat >= 4 ? 'translate-y-0 opacity-100' : 'translate-y-2 opacity-0'}`} data-id="element-158" data-mp="3no5nwt1isx4">
        Small deviations can alter force vectors.
      </p>

      <p className={`mt-3 font-body text-[13px] leading-relaxed text-white/55 transition-opacity duration-300 ease-out ${beat >= 5 ? 'opacity-100' : 'opacity-0'}`} data-id="element-159" data-mp="1oywl10lng8hx">
        The force delivered can differ from the force planned.
      </p>

      <div className={`mt-5 flex justify-end transition-opacity duration-300 ease-out ${beat >= 6 ? 'opacity-100' : 'opacity-0'}`} data-id="element-160" data-mp="1rh85zzijygx1">
        <PillButton variant="outline" onClick={onOpenPoll} data-id="element-161" data-mp="1ijfnkmhjat5f">
          Your view?
        </PillButton>
      </div>
    </section>;
}